import ApiService from 'services/ApiService'

export async function apiSignIn (data) {
    return ApiService.fetchData({
        url: '/auth/login',
        method: 'post',
        data
    })
}
export async function apiSignInWithDigital (data) {
    return ApiService.fetchData({
        url: `/sso/${data?.operation_id}/login/${data?.token}`,
        method: 'get'
    })
}
export async function apiUserSignIn (data) {
    return ApiService.fetchData({
        url: '/user/auth/login',
        method: 'post',
        data
    })
}
